/**
 * Trigger: tr_creditor_payments_soft_delete
 * Purpose: Update account balances and creditor totals when a creditor payment is soft deleted
 * Table: creditor_payments
 * Event: UPDATE OF is_deleted
 */
export const TR_CREDITOR_PAYMENTS_SOFT_DELETE = `
CREATE TRIGGER tr_creditor_payments_soft_delete
UPDATE OF is_deleted ON creditor_payments
BEGIN
  UPDATE account_balances
  SET creditor_payments_amount = CASE
    WHEN new.is_deleted = 0 THEN creditor_payments_amount + old.amount
    ELSE creditor_payments_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND new.is_deleted <> old.is_deleted;

  UPDATE account_daily_balances
  SET creditor_payments_amount = CASE
    WHEN new.is_deleted = 0 THEN creditor_payments_amount + old.amount
    ELSE creditor_payments_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.payment_date
    AND new.is_deleted <> old.is_deleted;

  UPDATE creditors
  SET total_amount = total_amount - old.amount
  WHERE new.is_deleted != 0
    AND _id = old.creditor_id;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
